export const styles = () => ({
  dialogRoot: {
    maxWidth: 520,
    padding: '10px 15px',
  },
  paragraph: {
    '& + &': {
      marginTop: 8,
    },
  },
  spinnerWrapper: {
    minHeight: 70,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  spinner: {
    display: 'flex',
  },
  textBold: {
    fontWeight: '600',
  }
});
